'use strcit';

angular.module('editcenterAppPushNewsModule', [])
    .controller('editcenterAppPushNewsModuleCtrl', ['$scope', '$state', '$modalInstance', 'modalDialog', 'obj', 'trsHttpService', '$filter',
        function ($scope, $state, $modalInstance, modalDialog, obj, trsHttpService, $filter) {
            initStatus();
            // initData();

            /**
             * [initStatus description]初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.data = {
                    title: obj.TITLE.substring(0, 50), // 稿件标题
                    abstract: obj.ABSTRACTFORPUSH === '' ? obj.ABSTRACT === '' ? '' : obj.ABSTRACT : obj.ABSTRACTFORPUSH // 稿件内容
                };
                $scope.status = {
                };
            }

            /**
             * [initData description] 初始化数据
             * @return  {[type]}  [return description]
             */
            function initData() {

            }



            /**
             * [cancel description]取消操作
             * @return {[type]} [description]
             */
            $scope.cancel = function () {
                $modalInstance.dismiss();
            };


            /**
             * [isConfirm description]确定操作
             * @return {Boolean} [description]
             */
            $scope.isConfirm = function () {   
                obj.editTitle = $scope.data.title;
                obj.editAbstract = $scope.data.abstract;  
                if (obj.editTitle.length > 50 || (obj.editAbstract && obj.editAbstract.length > 200)) {
                    modalDialog.alertType('', '标题或摘要超过规定字数', 'info', 'confirm', function () { });
                    return;
                } 
                $modalInstance.close(obj);                 
            };
        },
    ]);
